var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 10,
    fill: "#FF914D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 4,
    height: 30,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 30,
    rx: 2,
    transform: "matrix(1 0 0 -1 23 40)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 30,
    rx: 2,
    transform: "matrix(-1 0 0 1 37 10)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 22,
    r: 3.125,
    fill: "#FF914D",
    stroke: "white",
    strokeWidth: 1.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 3.125,
    transform: "matrix(1 0 0 -1 25 29)",
    fill: "#FF914D",
    stroke: "white",
    strokeWidth: 1.75
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 3.125,
    transform: "matrix(-1 0 0 1 35 18)",
    fill: "#FF914D",
    stroke: "white",
    strokeWidth: 1.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.e2dc0d125a16dcab58b539dc94bad73b.svg";
export { ForwardRef as ReactComponent };